package com.essntl.uikit.components.dropdown

import androidx.compose.foundation.LocalIndication
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.ripple.rememberRipple
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.icons.EsMediumIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.Accent200
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun EsDropdownMenuItem(
    text: String?,
    textColor: Color? = null,
    hintText: String? = null,
    onClick: () -> Unit,
    prefixIcon: String? = null,
    suffixIcon: String? = null,
    iconColor: Color = LocalContentColor.current,
    selected: Boolean = false,
    starred: Boolean = false,
    enabled: Boolean = true,
    fillMaxWidth: Boolean = true,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    modifier: Modifier = Modifier,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = modifier
            .clip(CircleShape)
            .background(
                color = with(MaterialTheme.esColorScheme) {
                    if (selected)
                        tinted
                    else if (starred)
                        Accent200
                    else
                        Color.Transparent
                },
            )
            .pointerHoverIcon(if (enabled) PointerIcon.Hand else PointerIcon.Default)
            .clickable(
                enabled = enabled,
                onClick = onClick,
                interactionSource = interactionSource,
                indication = if (enabled) LocalIndication.current else null,
            )
            .then(
                if (fillMaxWidth)
                    Modifier.fillMaxWidth()
                else
                    Modifier,
            )
            .padding(1.spacing),
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            prefixIcon?.let {
                EsMediumIcon(
                    res = it,
                    tint = iconColor,
                )
            }

            if (text != null)
                Text(
                    text = text,
                    color = if (enabled) textColor
                        ?: MaterialTheme.esColorScheme.textPrimary else MaterialTheme.esColorScheme.textDisabled,
                    style = MaterialTheme.esTypography.p2Regular14,
                )
        }

        if (hintText != null)
            Text(
                text = hintText,
                color = MaterialTheme.esColorScheme.textDisabled,
                style = MaterialTheme.esTypography.p2Regular14,
            )

        suffixIcon?.let {
            EsMediumIcon(
                res = it,
                tint = iconColor,
            )
        }
    }
}